import {
	IconBook2,
	IconCalendar,
	IconCalendarEvent,
	IconDownload,
	IconUsersGroup,
	IconVideo,
} from "@tabler/icons-react"
import { type FC } from "react"

import type { LandingPageProductHighlightBlock, ProductHighlightProductType } from "@forento/core/models/landing"

const productTypeIcons: Record<ProductHighlightProductType, FC<{ className?: string }>> = {
	course: IconBook2,
	downloadable: IconDownload,
	video: IconVideo,
	session: IconCalendarEvent,
	event: IconCalendar,
	membership: IconUsersGroup,
}

type Props = { block: LandingPageProductHighlightBlock }
const ProductHighlightBlockPreview: FC<Props> = ({ block }) => {
	const PlaceholderIcon = productTypeIcons[block.content.productType]

	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-7xl">
				{block.content.title && (
					<h2 className="text-landing-foreground mb-12 text-center text-3xl font-bold tracking-tight sm:text-4xl">
						{block.content.title}
					</h2>
				)}
				<div className="border-landing-border bg-landing-surface grid overflow-hidden rounded-3xl border shadow-sm lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-center">
					<div className="bg-landing-surface-muted relative block aspect-video overflow-hidden">
						<div className="from-landing-surface-muted to-landing-border flex size-full items-center justify-center bg-linear-to-br">
							<PlaceholderIcon className="text-landing-foreground-subtle size-16 sm:size-20" />
						</div>
					</div>
					<div className="flex min-h-0 flex-col justify-center p-6 sm:p-8 lg:p-10">
						<h3 className="text-landing-foreground line-clamp-2 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
							{block.content.productId === null ? "Select a product" : "Selected product"}
						</h3>
						<p className="text-landing-foreground-muted mt-4 line-clamp-4 max-w-2xl text-sm leading-6 sm:text-base sm:leading-7">
							The selected product short description will appear here.
						</p>
						<div className="mt-5 flex flex-wrap items-center gap-3">
							<span className="landing-button inline-flex items-center px-5 py-3 text-sm font-semibold">
								View product
							</span>
							<span className="text-landing-foreground font-semibold">Price</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ProductHighlightBlockPreview
